import * as React from "react";

import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { maskAddress } from "@hl/shared-features/lib/utils/content";
import { Anchor, Box, CopyButton, Group, Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";

import { ReactComponent as BracketsEllipsisIcon } from "assets/icons/brakets-ellipsis.svg";
import { TOOLS_URL } from "config";
import { GetManageCollectionQuery } from "~/features/manage-collection/v2.queries.graphql.generated";
import { PropertyBox } from "~/features/tokens/sections/ManageToken/properties/PropertyBox";

export const ContractProperty = ({
  contract,
}: {
  contract?: GetManageCollectionQuery["getManageCollection"]["contract"];
}) => {
  return (
    <PropertyBox
      label="Contract"
      value={
        <>
          <Group>
            <BracketsEllipsisIcon />
            <Stack spacing={0}>
              <Text size="sm">{contract?.name}</Text>
              <Text size="xs" color={TEXT_COLOR.SECONDARY}>
                {contract?.type} (ERC-721)
              </Text>
              <Box lh={0}>
                <Text size="xs" color={TEXT_COLOR.SECONDARY} span>
                  {maskAddress(contract?.contractAddress || "", 6, 4)} ·{" "}
                </Text>
                <CopyButton value={contract?.contractAddress || ""}>
                  {({ copied, copy }) => (
                    <Anchor onClick={copy} underline={false} size="xs" span>
                      {copied ? "Copied!" : "Copy address"}
                    </Anchor>
                  )}
                </CopyButton>
              </Box>
            </Stack>
          </Group>
          <Text
            component={Link}
            to={TOOLS_URL.contract.detail.replace(
              ":contractId",
              contract?.contractAddress || ""
            )}
            target="_blank"
          >
            <Text size="sm" fw={500}>
              View
            </Text>
          </Text>
        </>
      }
    />
  );
};
